import React, { useEffect } from "react";
import { Weekday } from "model";
import "./styles.css";
import{ useStateManager } from "bcms-react";

/**
 * @function UINotifiDayPicker
 * @param {STRING} className - Set additional class names.
 * @return {React.Component}
 * @exported true
 * @description This is the day picker used in QuietTimesWidget and ScheduleAlertWidget components.
 * @example
 * <UINotifiDayPicker className="test-name" />
 */
export default function UINotifiDayPicker(props) {
  const alertDetail = props.alertDetail ?? {};
  const scheduledAlert = props.scheduledAlert ?? {};
  const className = props.className ?? "";
  const updateScheduledTimeWeekdays = props.updateScheduledTimeWeekdays ?? (() => {});
  const timeAlerts = Weekday.initAll()
  .reduce((acc, item) => {
      let isSelected = false;
      if(scheduledAlert.weekdayIDs) isSelected = scheduledAlert.weekdayIDs.includes(item.id);

      acc.push(
          <UINotifiDay key={ item.id } className={ item.descriptionLowercase } 
          updateScheduledTimeWeekdays={ updateScheduledTimeWeekdays(alertDetail.id, "weekdayIDs") }
          weekday={ item } label={ item.descriptionAbbrv } checked={ isSelected } />
      );

      return acc;
  }, []);


  return (
    <div className={`ui-notifi-day-picker flex-container flex-horizontal align-center ${className}`}>
      { timeAlerts }
    </div>
  );
}

function UINotifiDay(props) {
  const weekday = props.weekday ?? {};
  const className = props.className ?? "";
  const label = props.label ?? "[label]";
  const updateScheduledTimeWeekdays = props.updateScheduledTimeWeekdays ?? (() => {});
  let checkedProp = props.checked === true ? { checked: true } : { checked: false };

  const onChange = evt => {
    updateScheduledTimeWeekdays(weekday.id, checkedProp.checked);
  }

  return (
    <label tabIndex="0" className={`ui-notifi-day flex-container flex-horizontal align-center set-width ${className}`}>
      <input type="checkbox" { ...checkedProp } onChange={ onChange }/>
      <span className="ui-notifi-day-indicator"></span>
      <span className="ui-notifi-day-label flex-width">{label}</span>
    </label>
  );
}
